/**
 * 🎨 AUTH LAYOUT COMPONENT
 * 
 * Extrage logica de layout pentru utilizatorii neautentificați din App.tsx
 * pentru a transforma App.tsx într-un orchestrator curat.
 * 
 * Responsabilități:
 * - Full screen height centering pentru login/register pages
 * - Proper flex alignment pentru auth forms
 * - Loading states pentru authentication process
 * 
 * Folosește clase Tailwind directe care funcționează
 */

import React from 'react';
import { Outlet } from "react-router";
import { cn } from '../../styles/cva-v2';

interface AuthLayoutProps {
  /** Additional CSS classes */
  className?: string;
}

/**
 * Layout component pentru utilizatorii neautentificați
 * Gestionează centrarea pe ecran pentru formularele de autentificare
 */
const AuthLayout = ({
  className
}: AuthLayoutProps) => {
  return (
    <main className={cn(
      // Full screen height cu centare perfectă
      'min-h-screen',
      'flex items-center justify-center',
      className
    )}>
      <Outlet />
    </main>
  );
};

export default AuthLayout; 